/**
 * smym-app API Worker (events + public registrations). Set per environment in `.env.*`:
 * - REACT_APP_API_BASE_URL — e.g. https://api.smymchennai.in (no trailing slash)
 * - REACT_APP_TURNSTILE_SITE_KEY — Cloudflare Turnstile site key for the registration form
 */
/** Read at call time so a test can set the env before resolving a flyer URL. CRA inlines this at build. */
export function eventsApiBaseUrl() {
  return String(process.env.REACT_APP_API_BASE_URL || "")
    .trim()
    .replace(/\/+$/, "");
}

export const EVENTS_API_BASE_URL = eventsApiBaseUrl();

export const TURNSTILE_SITE_KEY = String(
  process.env.REACT_APP_TURNSTILE_SITE_KEY || "",
).trim();
